import { useStore } from "vuex";

export default function useAccessibilityButton() {
  const store = useStore();

  function loadAccessibilityPlugin() {
    store.dispatch("setAccessible", true);

    if (window.location.href.indexOf("login") === -1) {
      (function install() {
        const s = document.createElement("script");
        const e = !document.body
          ? document.querySelector("head")
          : document.body;
        s.src = "https://acsbapp.com/apps/app/dist/js/app.js";
        s.async = true;
        s.onload = function onload() {
          // DO NOT REMOVE NEXT TWO LINES - they ensure that acsbJS doesnt throw undefined error
          /* global acsbJS */
          /* eslint no-undef: "error" */
          acsbJS.init({
            statementLink: "",
            footerHtml: "Rocket Alumni Solutions Accessibility Interface",
            hideMobile: false,
            hideTrigger: false,
            language: "en",
            position: "right",
            leadColor: "#146FF8",
            triggerColor: "#146FF8",
            triggerRadius: "50%",
            triggerPositionX: "right",
            triggerPositionY: "bottom",
            triggerIcon: "people",
            triggerSize: "medium",
            triggerOffsetX: 20,
            triggerOffsetY: 50,
            mobile: {
              triggerSize: "small",
              triggerPositionX: "right",
              triggerPositionY: "bottom",
              triggerOffsetX: 10,
              triggerOffsetY: 10,
              triggerRadius: "50%",
            },
          });
        };
        e.appendChild(s);
      })();
    }
  }

  return {
    loadAccessibilityPlugin,
  };
}
